import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteOperationWindowRules } from '@api/operationWindowRules';

import { TOperationWindowRulesDeleteManyDTO } from '@interfaces/cmModule/dto/operationWindowRulesDTO';
import { IPartialOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { OPERATION_WINDOW_RULES, OPERATION_WINDOW_RULES_DELETE_MANY  } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateOperationWindowRulesDeleteManyReturned {
	isLoadingDeleteOperationWindowRules: boolean;
	deleteOperationWindowRules: UseMutateFunction<any, any, TOperationWindowRulesDeleteManyDTO, any>;
}

const useMutateOperationWindowRulesDeleteMany = ({
	onSuccess,
}: IPartialOnSuccess): IUseMutateOperationWindowRulesDeleteManyReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<TOperationWindowRulesDeleteManyDTO>({
		mutationKey: [OPERATION_WINDOW_RULES_DELETE_MANY],
		mutationFn: deleteOperationWindowRules,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.deleteOperationWindowRules,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([OPERATION_WINDOW_RULES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		isLoadingDeleteOperationWindowRules: isLoading,
		deleteOperationWindowRules: mutate,
	};
};

export default useMutateOperationWindowRulesDeleteMany;
